<h1 mat-dialog-title>
  <app-titulo-paginas [titulo]="title"></app-titulo-paginas>
</h1>
<mat-dialog-content *ngIf="!loadingServiceDate;else templateLoading">
  <div class="row">
    <div class="col-lg-12">
      <div class="alert alert-info">
        <div class="card-header">
          <span class="fas fa-user"> </span>
          <strong> Paciente: </strong> {{ data?.paciente?.pessoa?.nome | titlecase}}
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-4 text-center">
      <label for="mes">Mês de referência</label>
      <p>{{ reportUtil.formatMounth(data.mes) }}</p>
    </div>
    <div class="col-lg-4 text-center">
      <label for="ano">Ano de referência</label>
      <p>{{ data.ano }}</p>
    </div>
    <div class="col-lg-4 text-center">
      <label for="ano">Serviço</label>
      <p>{{ data.servico ? data.servico.descricao : '' }}</p>
    </div>
  </div>
  <div class="row" *ngIf="days">
    <div class="col-lg-12">
      <h5 class="text-center">Atendimentos realizados</h5>
    </div>
    <div class="row col-lg-12" style="justify-content: center;">
      <mat-card class=" alert alert-warning" style="margin: 5px; justify-content: center;"
        *ngFor="let day of days; let i = index">
        <mat-card-content>
          <div class="row" style="justify-content: center; margin: 0">
            <p style="color: rgba(0,0,0,.54);">
              <i class="fas fa-calendar-alt" style="color: #49a28f"></i>
              Data:
              &nbsp;
            </p>
            <p>
              {{ day?.dataentrada | date: 'dd/MM/yyyy' }}
            </p>
          </div>
          <div class="row" style="justify-content: center; margin: 0;">
            <p style="color: rgba(0,0,0,.54);">
              <i class="fas fa-stethoscope" style="color: #49a28f"></i>
              Serviço:
              &nbsp;
            </p>
            <p>
              {{ day?.servico?.descricao }}
            </p>
          </div>
          <div class="row" style="justify-content: center; margin: 0;">
            <p style="color: rgba(0,0,0,.54);">
              <i class="fas fa-user-md" style="color: #49a28f"></i>
              Profissional:
              &nbsp;
            </p>
            <p>
              {{ day?.prestador.pessoa.nome | titlecase }}
            </p>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div *ngIf="data.ml_service_forecast">
    <div class="row" style="border-bottom: 1px solid;">
      <div class="col-lg-12">
        <h5 class="text-center">Previsões de atendimentos</h5>
      </div>
    </div>
    <div class="row col-lg-12" style="justify-content: center;">
      <mat-card style="margin: 5px; justify-content: center;"
        *ngFor="let item of data.ml_service_forecast; let i = index">
        <mat-card-content>
          <div class="row" style="justify-content: center; margin: 0">
            <p style="color: rgba(0,0,0,.54);">
              <i class="fas fa-calendar-alt" style="color: #49a28f"></i>
              Data:
              &nbsp;
            </p>
            <p>
              {{ item.date | date: 'dd/MM/yyyy' }}
            </p>
          </div>
          <div class="row" style="justify-content: center; margin: 0;">
            <p style="color: rgba(0,0,0,.54);">
              <i class="fas fa-stethoscope" style="color: #49a28f"></i>
              Serviço/Obs:
              &nbsp;
            </p>
            <p>
              {{ item.observation }}
            </p>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <label for="general_report">Relatório Geral</label>
      <p>{{ data.general_report }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <label for="inclusion_diagnosis">Diagnóstico inclusivo</label>
      <p>{{ data.inclusion_diagnosis }}</p>
    </div>
    <div class="col-lg-6">
      <label for="historico_clinico">Histórico Clínico</label>
      <p>{{ data.historico_clinico }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <label for="hospitalization_summary">Resumo da Internação</label>
      <p>{{ data.hospitalization_summary }}</p>
    </div>
    <div class="col-lg-6">
      <label for="month_evolution">Evolução Mensal</label>
      <p>{{ data.month_evolution }}</p>
    </div>
  </div>
  <div *ngIf="(data.pa != null || data.p != null || data.t != null || data.fr != null || data.sat != null)">
    <div class="row"  style="border-bottom: 1px solid;">
      <div class="col-lg-12">
        <h5 class="text-center">Sinais Vitais</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3" *ngIf="data.pa != null">
        <label for="pa">Pressão Arterial</label>
        <p>{{ data.pa }}</p>
      </div>
      <div class="col-lg-3" *ngIf="data.p != null">
        <label for="p">Pulso</label>
        <p>{{ data.p }}</p>
      </div>
      <div class="col-lg-3" *ngIf="data.t != null">
        <label for="t">Temperatura</label>
        <p>{{ data.t }}</p>
      </div>
      <div class="col-lg-3" *ngIf="data.fr != null">
        <label for="fr">Frequência</label>
        <p>{{ data.fr }}</p>
      </div>
      <div class="col-lg-3" *ngIf="data.sat != null">
        <label for="sat">Saturação</label>
        <p>{{ data.sat }}</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <label for="equipamentos_domicilio">Equipamentos</label>
      <p>{{ data.equipments }}</p>
    </div>
    <div class="col-lg-6">
      <label for="dispositivo">Dispositivo</label>
      <p>{{ data.dispositivo }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <label for="quadro_motor">Quadro Motor</label>
      <p>{{ data.quadro_motor }}</p>
    </div>
    <div class="col-lg-6">
      <label for="quadro_respiratorio">Quadro Respiratório</label>
      <p>{{ data.quadro_respiratorio }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <label for="systems">Sistemas (gastrintestinais, geniturinário, pele e tegumento)</label>
      <p>{{ data.systems }}</p>
    </div>
    <div class="col-lg-6">
      <label for="guidelines_conduct">Orientações e Conduta</label>
      <p>{{ data.guidelines_conduct }}</p>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6">
      <label for="metas_terapeuticas">Metas Terapêuticas (prognóstico)</label>
      <p>{{ data.metas_terapeuticas }}</p>
    </div>
    <div class="col-lg-6">
      <label for="systems">Justificativa</label>
      <p>{{ data.justifications }}</p>
    </div>
  </div>

  <div class="row">
    <!-- Fonoaudiologia -->
    <div class="col-lg-6" *ngIf="data.plano_terapeutico != null">
      <label for="plano_terapeutico">Plano Terapêutico Atual</label>
      <p>{{ data.plano_terapeutico }}</p>
    </div>
    <div class="col-lg-6" *ngIf="data.objetivo != null">
      <label for="objetivo">Objetivo</label>
      <p>{{ data.objetivo }}</p>
    </div>
  </div>

</mat-dialog-content>
<ng-template #templateLoading>
  <div class="text-center">
    <i class="fas fa-spin fa-spinner fa-5x"></i>
    <p>
      Carregando informações...
    </p>
  </div>
</ng-template>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <button type="button" class="btn btn-secondary" (click)="dialogRef.close()" style="border-radius: 19px;">
    Fechar
  </button>
</mat-dialog-actions>
